// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "中国近现代史纲要",
      "tec": "夏彬",
      "week": "1-10,13-14周",
      "add": "教学楼A座127信息"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "张敏夫",
      "week": "1-10,13-14周",
      "add": "教学楼C座210教务"
    },
    {
      "sub": "电路（一）（俄）",
      "tec": "孙云鹏",
      "week": "1-10周",
      "add": "312国教"
    },
    0
  ],
  "2": [
    {
      "sub": "大学物理（下)",
      "tec": "李春霞",
      "week": "1-10,13-16周",
      "add": "317国教"
    },
    {
      "sub": "数字电子技术（俄）",
      "tec": "曲延华",
      "week": "1-8周",
      "add": "实训楼F座101自控"
    },
    {
      "sub": "电路（一）（俄）",
      "tec": "孙云鹏",
      "week": "1-10周",
      "add": "312国教"
    },
    {
      "sub": "英语听说（三）",
      "tec": "外教6",
      "week": "1-10,13-16周",
      "add": "203国教"
    },
    {
      "sub": "就业创业指导",
      "tec": "孙笑雨",
      "week": "1-5周",
      "add": "教学楼C座214教务"
    }
  ],
  "3": [
    {
      "sub": "工程制图与CAD（俄）",
      "tec": "潘萍萍",
      "week": "1-6周",
      "add": "教学楼A座215机房"
    },
    {
      "sub": "复变函数与积分变换",
      "tec": "于智慧",
      "week": "1-10,13-18周",
      "add": "教学楼B座325能动"
    },
    0,
    0,
    {
      "sub": "概率论与数理统计",
      "tec": "张敏夫",
      "week": "1-10,13-14周",
      "add": "教学楼C座212教务"
    }
  ],
  "4": [
    {
      "sub": "数字电子技术（俄）",
      "tec": "曲延华",
      "week": "1-8周",
      "add": "实训楼F座101自控"
    },
    {
      "sub": "大学物理（下)",
      "tec": "李春霞",
      "week": "1-10,13-16周",
      "add": "317国教"
    },
    {
      "sub": "电路（一）（俄）",
      "tec": "孙云鹏",
      "week": "1-10周",
      "add": "312国教"
    },
    {
      "sub": "形势与政策",
      "tec": "王姝",
      "week": "1-4周",
      "add": "教学楼C座310教务"
    },
    0
  ],
  "5": [
    {
      "sub": "中国近现代史纲要",
      "tec": "夏彬",
      "week": "1-10,13-14周",
      "add": "教学楼A座127信息"
    },
    {
      "sub": "工程制图与CAD（俄）",
      "tec": "潘萍萍",
      "week": "1-6周",
      "add": "教学楼A座215机房"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "搏击",
        "tec": "李莉",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "女篮",
        "tec": "郝策",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男网",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男羽",
        "tec": "李灏",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男乒",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男篮",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "足球",
        "tec": "王莹莹",
        "week": "1-3,5-18周",
        "add": "健美操"
      },
      {
        "sub": "男网",
        "tec": "张慧",
        "week": "1-18周",
        "add": "健美操"
      }
    ],
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
